import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './delivermore.css'

const DeliverMore = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>Earn more by delivering more</h1>
      <div className={commonStyles.subheading}>
        Another great opportunity to increase your revenue is to make your <strong>stems and/or multitracks</strong> available for
        licensing. Tracks with stems/multitracks are downloaded on average 20x more than those without, and they also have a 13x higher
        likelihood of getting licensed
      </div>
      <div className={styles.imageWrapper}>
        <img src="/static/images/interestform/stem-diagram.jpg" alt="Stem diagram" />
      </div>
    </motion.div>
  )
}

export default DeliverMore
